import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import ProgressBar from "../common/ProgressBar";
import Button from "material-ui/Button";

const styles = () => ({
  root: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  cancelBtn: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "15px 23px 0px 0px",
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
  },
});

/**
 * Salesforce連携のプログレスバーのラッパーコンポーネント
 */
class SalesforceProgressBar extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <div className={classes.progressbar}>
          <ProgressBar
            step={this.props.step}
            steps={this.props.steps}
          />
          <Button
            className={classes.cancelBtn}
            onClick={() => {
              if (
                window.confirm(
                  "設定をキャンセルします。よろしいですか？"
                )
              ) {
                this.props.goToSalesforceSettingHome();
              }
            }}
          >
            キャンセル
          </Button>
        </div>
        {this.props.children}
      </div>
    );
  }
}

SalesforceProgressBar.propTypes = {
  classes: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  goToSalesforceSettingHome: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(SalesforceProgressBar);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceProgressBar.jsx